var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoqrcode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 165 165",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.539703,
    width: 164,
    height: 164,
    rx: 6,
    fill: "#F1F3F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.5 52.8522C66.104 52.8522 52.8125 66.1438 52.8125 82.5397C52.8125 98.9357 66.104 112.227 82.5 112.227C98.896 112.227 112.188 98.9357 112.188 82.5397C112.188 66.1438 98.896 52.8522 82.5 52.8522ZM45.6875 82.5397C45.6875 62.2087 62.169 45.7272 82.5 45.7272C102.831 45.7272 119.312 62.2087 119.312 82.5397C119.312 102.871 102.831 119.352 82.5 119.352C62.169 119.352 45.6875 102.871 45.6875 82.5397Z",
    fill: "#E3E7F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.9375 87.2897V63.5397H86.0625V87.2897H78.9375Z",
    fill: "#E3E7F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5 101.54C85.1234 101.54 87.25 99.4131 87.25 96.7897C87.25 94.1664 85.1234 92.0397 82.5 92.0397C79.8766 92.0397 77.75 94.1664 77.75 96.7897C77.75 99.4131 79.8766 101.54 82.5 101.54Z",
    fill: "#E3E7F2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoqrcode);
export default __webpack_public_path__ + "static/media/noqrcode.69e75b3b31558d1f8217f0703874264f.svg";
export { ForwardRef as ReactComponent };